/*!
 * vue-coe-validator v0.4.2
 * (c) 2018-present Vinicius Azevedo <viniazvd@gmail.com>
 * Released under the MIT License.
 */
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getContext() {
  var vm = this.$validator || this;
  var componentID = Object.keys(vm.context.components)[Object.keys(vm.context.components).length - 1];
  return vm.context.components[componentID];
}
function setContext() {
  var obj;

  this.$validator.context.components = Object.assign({}, this.$validator.context.components, ( obj = {}, obj[this._uid] = this, obj));
}

function setMessages(source, newMessages) {
  for (var form of Object.values(source)) {
    for (var input of Object.values(form)) {
      for (var messageKey of Object.keys(input)) {
        if (newMessages[messageKey]) {
          input[messageKey] = newMessages[messageKey];
        }
      }
    }
  }
}
var defaultState = {
  isLoading: false,
  isChanged: false,
  isTouched: false,
  isDirty: false,
  isFilled: false,
  isValid: false,
  errors: []
};
function getData() {
  /* eslint-disable */
  var _this$$data = this.$data;
  var validations = _this$$data.validations; if ( validations === void 0 ) validations = {};
  var messages = _this$$data.messages; if ( messages === void 0 ) messages = {};
  var data = _objectWithoutPropertiesLoose(_this$$data, ["validations", "messages"]);
  /* eslint-enable */


  return data;
}
function setValidation(form, field) {
  var this$1 = this;

  var unwatch = this.$watch(form.concat('.', field), function () {
    this$1.$validator.validateField(field, form);
  });
  this.$on('hook:beforeDestroy', unwatch);
}
function setProxy() {
  // issue!?
  // setProxy works...
  // however, it creates a deep proxy reference.
  var validationsProxy = new Proxy(this.validations, {
    deleteProperty: function deleteProperty(target, prop) {
      if (prop in target) {
        process.env.NODE_ENV === 'development' && console.warn("you can not remove validations property.");
        return true;
      }
    },

    get: function get() {
      return Reflect.get.apply(Reflect, arguments);
    },

    set: function set(target, prop) {
      process.env.NODE_ENV === 'development' && console.warn(("please dont reasign properties on " + prop + "."));
      return true;
    }

  });
  this.validations = validationsProxy;
}

function forceValidation(form, element, field, value) {
  if ( field === void 0 ) field = element.name;
  if ( value === void 0 ) value = element.value;

  var vm = getContext.call(this);
  vm.validations[form][field].isTouched = true;
  this.$validator.validateField(field, form);
}

function addTouchListener(formName, inputElement) {
  var this$1 = this;

  var inputName = inputElement && inputElement.getAttribute('name');
  var validations = inputElement && this.validations[formName] && this.validations[formName][inputName] || {};
  var hasValidation = Object.keys(validations).length; // register events only for those who have validation

  if (hasValidation) {
    inputElement.addEventListener('blur', function () { return forceValidation.call(this$1, formName, inputElement); }, {
      once: true
    });
  }
}
function setListener(form, field) {
  var vm = getContext.call(this);
  var inputElement = vm.$el.querySelector(("form[name=\"" + form + "\"] [name=\"" + field + "\"] > input"));
  addTouchListener.call(vm, form, inputElement);
}
function setListeners() {
  var vm = getContext.call(this); // dynamically records listeners to activate touch inputs

  vm.$nextTick(function () {
    // TO-DO. issue: does not work in tests
    var formListNode = vm.$el.querySelectorAll('form[name]');

    if (formListNode.length) {
      formListNode.forEach(function (NodeForm) {
        var form = NodeForm.getAttribute('name');
        Array.from(NodeForm).filter(function (node) { return node && !!node.attributes.name; }).forEach(function (inputElement) { return addTouchListener.call(vm, form, inputElement); });
      });
    } else {
      console.warn('follow the instructions in the documentation to correctly register the form');
    }
  });
}

var services = /*#__PURE__*/Object.freeze({
  setMessages: setMessages,
  defaultState: defaultState,
  getData: getData,
  setValidation: setValidation,
  setProxy: setProxy,
  addTouchListener: addTouchListener,
  setListener: setListener,
  setListeners: setListeners
});

function getField(key, value, rules) {
  var obj;

  var filled = {
    isFilled: !!value
  };
  var dirted = {
    isDirty: !!value
  };
  return ( obj = {}, obj[key] = Object.assign({}, defaultState, dirted, filled, rules), obj);
}

function setField(form, key, value, rules) {
  var obj;

  this.validations = Object.assign({}, this.validations, ( obj = {}, obj[form] = Object.assign({}, this.validations[form], getField(key, value, rules)), obj));
}

function add(form, key, value, rules) {
  var vm = getContext.call(this);
  var addByDirective = typeof form === 'string';
  var addByUser = typeof form === 'object';

  if (addByDirective) {
    // prevents actions already taken
    if (!vm['validations'][form][key]) {
      setField.call(vm, form, key, value, rules);
      setValidation.call(vm, form, key);
    }
  }

  if (addByUser) {
    Object.entries(form).forEach(function (ref) {
      var input = ref[0];
      var rules = ref[1];

      // prevents actions already taken
      if (!vm['validations'][key][input]) {
        // key === formName
        setField.call(vm, key, input, value = '', rules);
        setValidation.call(vm, key, input);
      }
    });
  }

  setProxy.call(vm);
}

var context = {
  components: {} // proposal....
  // let components = {}
  // export default {
  //   components,
  //   set (component, vm) {
  //     components = {
  //       ...components,
  //       components: vm
  //     }
  //   },
  //   get (component) {
  //     return components[component]
  //   }
  // }

};

function setValidations(form, validations) {
  var this$1 = this;

  Object.keys(validations).forEach(function (input) { return setValidation.call(this$1, form, input); });
}

function getFormFields(form, data, validation) {
  var obj;

  return ( obj = {}, obj[form] = Object.entries(validation).reduce(function (accForm, ref) {
      var input = ref[0];
      var rules = ref[1];

      var value = data[input];
      var filled = {
        isFilled: !!value
      };
      var dirted = {
        isDirty: !!value
      };
      accForm[input] = Object.assign({}, defaultState, dirted, filled, rules);
      return accForm;
    }, {}), obj);
}

function setFormFields(form, data, validation) {
  var newFormStates = getFormFields(form, data, validation);
  this.validations = Object.assign({}, this.validations, newFormStates);
}

function init() {
  var vm = getContext.call(this);
  var data = getData.call(vm);
  var validation = vm.$options.validation;

  var dataWithValidation = function (ref) {
    var key = ref[0];

    return !!(validation[key] && Object.keys(validation[key]).length);
  };

  Object.entries(data).filter(dataWithValidation).forEach(function (ref) {
    var form = ref[0];
    var fields = ref[1];

    setFormFields.call(vm, form, fields, validation[form]);
    setValidations.call(vm, form, validation[form]);
  });
  setProxy.call(vm);
}

function isFormValid (form) {
  var vm = getContext.call(this);
  if (!form) { form = Object.keys(vm.validations)[0]; }
  var fields = Object.keys(vm.validations[form]);
  var isFormValid = fields.every(function (field) { return vm.validations[form][field].isValid; });
  return new Promise(function (resolve) { return resolve(isFormValid); });
}

var defaultStates = ['isLoading', 'isChanged', 'isDirty', 'isFilled', 'isTouched', 'isValid'];

function hasField(form, field) {
  var vm = getContext.call(this);
  var isDevEnv = process.env.NODE_ENV === 'development';
  var hasForm = Object.keys(vm.validations[form]).includes(field);
  return hasForm && isDevEnv;
}

function resetState(state, value) {
  if (defaultStates.includes(state)) { return false; }
  if (state === 'errors') { return []; }
  return value;
}

function resetField(field, form) {
  var vm = getContext.call(this);
  if (!form) { form = Object.keys(vm.validations)[0]; }

  if (!hasField.call(vm, form, field)) {
    console.warn(("it was not possible to reset the " + form + " of a form that does not exist."));
    return false;
  }

  var states = vm.validations[form][field];
  vm.validations[form][field] = Object.entries(states).reduce(function (acc, ref) {
    var state = ref[0];
    var value = ref[1];

    acc[state] = resetState(state, value);
    return acc;
  }, {});
  vm.$validator.validateOnBlur && setListener.call(vm, form, field);
}

function hasForm(form) {
  var vm = getContext.call(this);
  var isDevEnv = process.env.NODE_ENV === 'development';
  var hasForm = Object.keys(vm.validations).includes(form);
  return hasForm && isDevEnv;
}

function resetForm (form) {
  var vm = getContext.call(this);
  if (!form) { form = Object.keys(vm.validations)[0]; }

  if (!hasForm.call(vm, form)) {
    console.warn(("it was not possible to reset the " + form + " of a form that does not exist."));
    return false;
  }

  var fields = Object.keys(vm.validations[form]);
  fields.forEach(function (field) { return vm.$validator.resetField(field, form); });
  vm.$validator.validateOnBlur && setListeners.call(vm);
}

var snapshots = {
  components: {}
};

function touch(key, form) {
  var vm = getContext.call(this);
  if (!form) { form = Object.keys(vm.validations)[0]; }
  var field = vm.validations && vm.validations[form] && vm.validations[form][key];
  var hasProperty = field && field.hasOwnProperty('isTouched');
  var isEnv = process.env.NODE_ENV === 'development';

  if (!hasProperty && isEnv) {
    console.warn('property not found.');
    return;
  }

  vm.validations[form][key].isTouched = true;
}

function alpha (value, msg) {
  return !Array.isArray(value) && !/^\s*([0-9a-zA-Z]*)\s*$/.test(value) && (msg || 'Must only contain letters and numbers');
}

function alphabetic (value, msg) {
  return !Array.isArray(value) && !/^[a-zA-Z]*$/.test(value) && (msg || 'Must be a alphabetic value');
}

function custom (value, msg, field) {
  var callbacks = field['custom'];
  var valid = callbacks.every(function (f) { return f(value); });
  return (!Array.isArray(callbacks) || !valid) && (msg || 'Campo inválido');
}

function customAsync (value, msg, field) {
  var callbacks = field['customAsync'];
  var promisses = callbacks.map(function (f) { return f(value); });
  return Promise.all(promisses).then(function (promises) { return promises.every(function (promise) { return promise; }); }).then(function (valid) { return (!Array.isArray(callbacks) || !valid) && (msg || 'Campo inválido'); });
}

function numeric (value, msg) {
  return !Array.isArray(value) && !/^[0-9]*$/.test(value) && (msg || 'Must be a numeric value');
}

function pattern (value, msg, field) {
  var pattern = field['pattern'];
  return value && !pattern.test(value) && (msg || 'Campo inválido');
}

function required (value, msg) {
  return !value && (msg || 'Field is required');
}



var VALIDATIONS = /*#__PURE__*/Object.freeze({
  alpha: alpha,
  alphabetic: alphabetic,
  custom: custom,
  customAsync: customAsync,
  numeric: numeric,
  pattern: pattern,
  required: required
});

var hasCustomAsyncRule = function (state) { return state['customAsync'] && state['customAsync'].length; };
function setActiveFields(state, value, isTouched, syncErrors) {
  state.errors = syncErrors;
  state.isChanged = true;
  state.isDirty = !!value || isTouched;
  state.isFilled = !!value;
  state.isTouched = true;
  state.isValid = !syncErrors.length;
}
function setInactiveFields(state, syncErrors) {
  state.errors = syncErrors;
  state.isValid = !syncErrors.length;
  state.isLoading = false;
}
var RULES = Object.keys(VALIDATIONS);

function isRule(rule, validations, form, key) {
  return validations[form] && validations[form][key] && validations[form][key][rule];
}

function getMessage(rule, messages, form, key) {
  return messages && messages[form] && messages[form][key] && messages[form][key][rule];
}

function getError(rule, value, msg, field) {
  return VALIDATIONS[rule](value, msg, field);
}

function getSyncErrors(validations, messages, form, key, value) {
  // TO-DO/issue: change to an immutable approach?
  var errors = [];
  RULES.some(function (rule) {
    if (isRule(rule, validations, form, key) && rule !== 'customAsync') {
      var msg = getMessage(rule, messages, form, key);
      var error = getError(rule, value, msg, validations[form][key]);
      if (error) { errors = errors.concat( [error]); }
    }
  });
  return errors;
}
function getAsyncErrors(validations, messages, form, key, value) {
  return new Promise(function ($return, $error) {
    var msg, error;
    msg = getMessage('customAsync', messages, form, key);
    return Promise.resolve(getError('customAsync', value, msg, validations[form][key])).then(function ($await_1) {
      try {
        error = $await_1;
        return $return(error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}

function validateField(key, form) {
  var vm = getContext.call(this);
  var validations = vm.validations;
  if (!form) { form = Object.keys(validations)[0]; }
  var messages = vm.messages;
  var value = vm[form][key];
  var state = validations[form][key];
  state.isLoading = true;
  var syncErrors = getSyncErrors(validations, messages, form, key, value);
  var isTouched = validations[form] && state && state.isTouched;
  setActiveFields(state, value, isTouched, syncErrors);
  if (!hasCustomAsyncRule(state) && value) { setInactiveFields(state, syncErrors); }

  if (hasCustomAsyncRule(state)) {
    getAsyncErrors(validations, messages, form, key, value).then(function (asyncErrors) {
      // must be filtered because asyncErrors is a boolean false or string
      // this prevents a 'false' value within errors
      state.errors = syncErrors.concat( [asyncErrors]).filter(Boolean);
      state.isValid = !state.errors.length;
      state.isLoading = false;
    });
  }
}

function validateForm (form) {
  var vm = getContext.call(this);
  if (!form) { form = Object.keys(vm.validations)[0]; }
  var fields = Object.keys(vm.validations[form]);
  fields.forEach(function (field) { return vm.$validator.validateField(field, form); });
}



var prototypes = /*#__PURE__*/Object.freeze({
  add: add,
  context: context,
  init: init,
  isFormValid: isFormValid,
  resetField: resetField,
  resetForm: resetForm,
  snapshots: snapshots,
  touch: touch,
  validateField: validateField,
  validateForm: validateForm
});

var messages = function (options) { return options && options.messages && {
  messages: options.messages
} || {}; };

var validateOnBlur = function (options) { return options && {
  validateOnBlur: options.validateOnBlur
}; };

var validator = {
  install: function install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$validator', {
      get: function get() {
        return Object.assign({}, prototypes, services, messages(options), validateOnBlur(options));
      }

    });
  }

};

function getSnapshots() {
  var validation = this.$options.validation;
  var data = getData.call(this);
  return Object.entries(data).reduce(function (acc, ref) {
    var dataKey = ref[0];
    var dataValue = ref[1];

    Object.keys(validation).forEach(function (validationKey) { return validationKey === dataKey && (acc[dataKey] = dataValue); });
    return acc;
  }, {});
}
function setSnapshot() {
  var obj;

  this.$validator.snapshots.components = Object.assign({}, this.$validator.snapshots.components, ( obj = {}, obj[this._uid] = getSnapshots.call(this), obj));
}

var isCustomInput = function (vnode) { return vnode.data.model; };

var model = function (vnode) { return vnode.data.directives.reduce(function (acc, item) {
  if (item.name === 'model') { acc[item.name] = item; }
  return acc;
}, {}).model; };

function getFormValues(vnode, el) {
  var assign, assign$1;

  var form, key, value, inputElement; // check native or custom input

  if (isCustomInput(vnode)) {
    (assign = vnode.data.model.expression.split('.'), form = assign[0], key = assign[1]);
    value = vnode.data.model.value;
    inputElement = el && el.querySelector('input');
  } else {
    (assign$1 = model(vnode).expression.split('.'), form = assign$1[0], key = assign$1[1]);
    value = model(vnode).value;
    inputElement = el;
  }

  return {
    form: form,
    key: key,
    value: value,
    inputElement: inputElement
  };
}

var validator$1 = {
  validator: {
    bind: function bind(el, binding, vnode) {
      var vm = vnode.context;
      var ref = getFormValues(vnode);
      var form = ref.form; // if the form property does not exist in validations, set.

      if (!vm.validations[form]) {
        vm.$set.call(vnode, vm.validations, form, {});
      }
    },

    inserted: function inserted(el, ref, vnode) {
      var rules = ref.value;

      var vm = vnode.context;
      var ref$1 = getFormValues(vnode, el);
      var form = ref$1.form;
      var key = ref$1.key;
      var value = ref$1.value;
      var inputElement = ref$1.inputElement; // add validation states/rules

      vm.$validator.add(form, key, value, rules); // set validate onBlur

      vm.$validator.validateOnBlur && addTouchListener.call(vm, form, inputElement);
    }

  }
};

var formSetup = {
  created: function created() {
    var ref = this.$options;
    var validation = ref.validation;
    var messages = ref.messages;
    this.messages = messages || null;

    if (validation) {
      // set the component context values
      setContext.call(this); // set snapshot of the initial form

      setSnapshot.call(this); // overrides default messages based on global message options

      if (this.$validator.messages && this.messages && this.messages.length) {
        setMessages(this.messages, this.$validator.messages);
      } // create validation states/rules


      this.$validator.init(); // set validate onBlur

      this.$validator.validateOnBlur && setListeners.call(this);
    }
  },

  directives: validator$1,

  data: function data() {
    return {
      validations: {},
      messages: {}
    };
  },

  methods: {
    $hasError: function $hasError(key, form) {
      if (this.validations && Object.keys(this.validations).length) {
        // in a single-form scenario, the scope is unique, and you do not have to explicitly name the form
        if (!form) { form = Object.keys(this.validations)[0]; }
        var input = this.validations[form] && this.validations[form][key];
        return input && input.isTouched && !input.isValid && input.errors[0];
      }

      return false;
    }

  }
};

export { validator, formSetup };
